import styled from 'styled-components'
import ArtboardRasterized from './rasterized'

export const Container = styled.div`
    position: relative;
`

export const RenderError = styled.div`
    align-items: center;
    background: #121212;
    box-sizing: border-box;
    color: #ffffff;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    padding: 24px;
    text-align: center;
    width: 100%;

    strong {
        font-size: 18px;
        line-height: 1.2;
        margin-bottom: 8px;
    }

    span {
        color: #a6a6a6;
        font-size: 14px;
        line-height: 1.4;
    }
`

export const RasterizedCanvas = styled(ArtboardRasterized)`
    display: block;
    border-radius: inherit;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
`
